/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { FantomPunksMarket } from "../FantomPunksMarket";

export class FantomPunksMarket__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<FantomPunksMarket> {
    return super.deploy(overrides || {}) as Promise<FantomPunksMarket>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): FantomPunksMarket {
    return super.attach(address) as FantomPunksMarket;
  }
  connect(signer: Signer): FantomPunksMarket__factory {
    return super.connect(signer) as FantomPunksMarket__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FantomPunksMarket {
    return new Contract(address, _abi, signerOrProvider) as FantomPunksMarket;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
    ],
    name: "Assign",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "fromAddress",
        type: "address",
      },
    ],
    name: "PunkBidEntered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "fromAddress",
        type: "address",
      },
    ],
    name: "PunkBidWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "fromAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "toAddress",
        type: "address",
      },
    ],
    name: "PunkBought",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
    ],
    name: "PunkNoLongerForSale",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minValue",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "toAddress",
        type: "address",
      },
    ],
    name: "PunkOffered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
    ],
    name: "PunkTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minPrice",
        type: "uint256",
      },
    ],
    name: "acceptBidForPunk",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
    ],
    name: "buyPunk",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
    ],
    name: "enterBidForPunk",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "getPunk",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "getRemaining",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "imageHash",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextPunkIndexToAssign",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minSalePriceInWei",
        type: "uint256",
      },
    ],
    name: "offerPunkForSale",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minSalePriceInWei",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "toAddress",
        type: "address",
      },
    ],
    name: "offerPunkForSaleToAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pendingWithdrawals",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "punkBids",
    outputs: [
      {
        internalType: "bool",
        name: "hasBid",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "bidder",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "punkIndexToAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
    ],
    name: "punkNoLongerForSale",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "punksOfferedForSale",
    outputs: [
      {
        internalType: "bool",
        name: "isForSale",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "seller",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minValue",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "onlySellTo",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "punksRemainingToAssign",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "standard",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
    ],
    name: "transferPunk",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "punkIndex",
        type: "uint256",
      },
    ],
    name: "withdrawBidForPunk",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
